import { ReactNode } from 'react';
import { Formik } from 'formik';

import useMenuStore from '../../../services/store/menuStore';
import { useRecentGeneratedTools } from '../../../services/store/recent-generated-tools.store';
import { getValidationSchema } from '../../../utils/common/yupSchema';
import { ToolCategory } from '../../../utils/common/types';
import useSubmit from '../../../utils/hooks/useSubmit';
import useStore from '../../../services/store';

type FormProps = {
  children: ReactNode;
  toolCategory: ToolCategory;
};

function FormContainer({ children, toolCategory: category }: FormProps) {
  const handleSubmit = useSubmit(category);
  const initialValues = useStore((state) => state.formValues);
  const addToolToRecents = useRecentGeneratedTools((state) => state.add);
  const categoryType = useMenuStore((state) => state.selectedMenuCategoryType);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={getValidationSchema(category)}
      onSubmit={(values, { setSubmitting }) => {
        addToolToRecents(category, categoryType);
        handleSubmit(values, setSubmitting);
      }}
    >
      {children}
    </Formik>
  );
}

export default FormContainer;
